import React, {useEffect, useState,Fragment,useContext,createContext} from "react";
import {merge} from "lodash";

import {scopeCustomCss} from './components/scopeCustomCss'


export const WebEditorRuntimeContext = createContext(null)

//[LANG]
export function applyLang(object,lang){
    if(!lang || !object[lang.value]){
        return object
    }

    let dataLang=object[lang.value]
    let dataMerge={}
    for(let k of Object.keys(dataLang)){
        const finalValue=checkValue(dataLang[k])
        if(finalValue){
            dataMerge[k]=finalValue
        }
    }

    return merge(object,dataMerge)
}

function checkValue(value){
    if(typeof value === "object"){
        let object={}
        for(let k of Object.keys(value)){
            const v=checkValue(value[k])
            if(v){
                object[k]=v
            }
        }
        return object
    }

    if(Array.isArray(value)){
        const array=[]
        for(let item of value){
            const sub=checkValue(item)
            if(sub){
                array.push(sub)
            }
        }
        return array
    }

    if(typeof value === "string"){
        value=value.trim()
    }

    if(value){
        return value
    }

    return null
}
//[LANG]

export function injectLayoutParams(plugins)
{
    return plugins.map(p=>{
        if(p.injectedLayoutParams || p.ignoreLayoutParams){
            return p
        }

        const renderer=p.Renderer
        p.Renderer=hookRenderer(renderer)

        p.injectedLayoutParams=true
        return p
    })
}


//RENDER

function hookRenderer(renderer){
    return (props)=>{
        //console.log(props)
        const runtime=useContext(WebEditorRuntimeContext)
        const data=runtime?.neutral ? {"_hidden-module":props.data?.["_hidden-module"]} : checkStyleValues(props.data)
        //console.log(data)

        var containerStyle={}
        var backgroundStyle={width:"100%"}
        var filterStyle={width:"100%"}
        var elementContainerStyle={width:"100%"}
        var elementStyle={}


        containerStyle=renderPadding(data,containerStyle)

        backgroundStyle=renderBackgroundContainer(data,backgroundStyle)

        filterStyle=renderBackgroundLight(data,filterStyle)

        elementContainerStyle=renderBackgroundAlign(data,elementContainerStyle)

        elementStyle=renderSize(data,elementStyle)

        if(!props.isEditMode){
            elementStyle=renderOverflow(data,elementStyle)
        }


        //console.log(elementStyle)
        //console.log(subElementStyle)

        const layoutId="layout-"+(runtime?.instanceId ? runtime.instanceId+"-" : "")+props.nodeId
        const backgroundlayoutId="bg-layout-"+(runtime?.instanceId ? runtime.instanceId+"-" : "")+props.nodeId
        let css = ``

        if(data._color && data._color!=="transparent"){
            css+="#"+layoutId+" * {color:"+data._color+" !important;}\n"
        }

        if(data._formLabelColor && data._formLabelColor!=="transparent"){
            css+="#"+layoutId+" .ant-form-item-label>label{color:"+data._formLabelColor+" !important;}\n"
            css+="#"+layoutId+" .layout-label{color:"+data._formLabelColor+" !important;}\n"
        }

        if(data["_background-custom-css"]){
            css+=scopeCustomCss("#"+backgroundlayoutId,data["_background-custom-css"])+"\n"
        }

        if(data["_hidden-module"]){
            return null
        }
        //console.log(css)

        return(
            <Fragment>
                <style>{runtime?.scopeCss ? runtime.scopeCss(css,"."+runtime.instanceId) : css}</style>
                <div id={backgroundlayoutId} style={backgroundStyle}>
                    <div id={layoutId} style={containerStyle}>

                        <div style={filterStyle}>

                            <div style={elementContainerStyle}>
                                <div style={elementStyle}>
                                    {renderer(props)}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

function hookStyleValue(value, indicator="px"){
    if(/^\d+$/.test(value)){
        return value+indicator
    }
    return value
}

function checkStyleValues(values){
    var allValues=values
    Object.keys(allValues).forEach(k=>{
        if(typeof allValues[k] === "string")
        {
            if(!allValues[k] || allValues[k].trim() === ""){
                allValues[k]=null
            }
        }
    })

    return allValues
}

function renderSize(data,style)
{
    style={...style,...{
            width:"100%",
            minWidth:"auto",
            maxWidth:"auto",

            height:"auto",
            minHeight:"auto",
            maxHeight:"auto",
        }}

    if(data["_height"]){
        style.height=hookStyleValue(data["_height"])
    }

    if(data["_min-height"]){
        style.minHeight=hookStyleValue(data["_min-height"])
    }

    if(data["_max-height"]){
        style.maxHeight=hookStyleValue(data["_max-height"])
    }


    if(data["_width"]){
        style.width=hookStyleValue(data["_width"],"%")
    }

    if(data["_min-height"]){
        style.minWidth=hookStyleValue(data["_min-width"],"%")
    }

    if(data["_max-width"]){
        style.maxWidth=hookStyleValue(data["_max-width"],"%")
    }

    return style
}

function renderOverflow(data,style)
{
    style={...style,...{overflow:"initial"}}

    if(data["_overflow"]){
        style.overflow=data["_overflow"]
    }

    return style
}

function renderPadding(data,style)
{
    style={...style,...{paddingTop:0,paddingBottom:0,paddingRight:0,paddingLeft:0}}

    if(data["_padding-top"]){
        style.paddingTop=hookStyleValue(data["_padding-top"])
    }else if(data["_padding"]){
        style.paddingTop=hookStyleValue(data["_padding"])
    }

    if(data["_padding-bottom"]){
        style.paddingBottom=hookStyleValue(data["_padding-bottom"])
    }else if(data["_padding"]){
        style.paddingBottom=hookStyleValue(data["_padding"])
    }

    if(data["_padding-left"]){
        style.paddingLeft=hookStyleValue(data["_padding-left"])
    }else if(data["_padding"]){
        style.paddingLeft=hookStyleValue(data["_padding"])
    }

    if(data["_padding-right"]){
        style.paddingRight=hookStyleValue(data["_padding-right"])
    }else if(data["_padding"]){
        style.paddingRight=hookStyleValue(data["_padding"])
    }

    return style
}

function renderBackgroundContainer(data,style)
{
    style={...style,...{
            borderRadius:"0",
            backgroundColor:"transparent",
            backgroundImage:null,
            backgroundSize:"cover",
            backgroundRepeat:"no-repeat",
            backgroundPosition:"center"
        }}

    if(data["_border-radius"]){
        style.borderRadius=hookStyleValue(data["_border-radius"])
    }

    if(data["_background-color"]){
        style.backgroundColor=data["_background-color"]
    }

    if(data["_background-image"]){
        style.backgroundImage="url('"+data["_background-image"]+"')"
    }

    if(data["_background-size"]){
        style.backgroundSize=data["_background-size"]
    }

    if(data["_background-position"]){
        style.backgroundPosition=data["_background-position"]
    }

    //console.log(data,style)

    return style
}

function renderBackgroundAlign(data,style)
{
    style={...style,...{
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
        }}


    if(data["_element-align"]){
        style.justifyContent=data["_element-align"]
    }

    return style
}

function renderBackgroundLight(data,style)
{
    var darken=0
    var lighten=0

    if(data["_background-darken"]){
        darken=data["_background-darken"]/100
    }

    if(data["_background-lighten"]){
        lighten=data["_background-lighten"]/100
    }

    return {...style,...{backgroundImage:`linear-gradient(rgba(0, 0, 0, ${darken}), rgba(0, 0, 0, ${darken})),linear-gradient(rgba(255, 255, 255, ${lighten}), rgba(255, 255, 255, ${lighten}))`}}
}
